import { Menu } from 'antd'

const { ItemGroup } = Menu

export const MenuItemGroup = ItemGroup
